import React, { useEffect, useState } from "react";
// import moment from "moment";
import { useDispatch, useSelector } from "react-redux";

import { Image, Modal, Spin } from "antd";

import partnersApi from "../../../apis/Partners.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ChannelCommentComponent from "../comment/ChannelCommentComponent";

import CommunityFavorite from "./CommunityFavorite";

const CommunityModal = ({
	modalShow,
	setModalShow,
	detail,
	getCommunityList,
	whereShow,
	scrollToComment,
}) => {
	const dispatch = useDispatch();
	const reduxChannel = useSelector((state) => state.channel.reduxChannel);
	const cUser = useSelector((state) => state.auth.channelUser);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [item, setItem] = useState({});

	const handleLoad = () => {
		const modal = document.getElementsByClassName("ant-modal-content");
		const commentScroll = document.getElementById(
			"community-comment-favorite-id"
		);
		if (scrollToComment) {
			if (modal) {
				// console.log(modal[0].scrollTop);
				if (!modal[0].scrollTop) {
					modal[0]?.scrollTo({
						// top: 0,
						top: commentScroll?.offsetTop,
						// behavior: 'smooth'
					});
				}
			}
		}
	};

	useEffect(() => {
		if (detail?.id && !item?.id) {
			getCommunity();
		}
		return () => {
			setIsLoading(false);
		};
	}, [detail, item, cUser]);

	const getCommunity = async () => {
		setIsLoading(true);
		try {
			let param = {
				influencerId: reduxChannel?.user_id ?? detail?.user_id,
				communityId: detail?.id,
				userId: cUser?.id ? cUser.id : 0,
				pageType: "user",
			};
			const res = await partnersApi.readCommunityEach(param);
			if (res.code === 200) {
				setItem(res.result);
			}
		} catch (e) {
			console.log(e);
		}
		setIsLoading(false);
	};

	return (
		<Modal
			// title="인기검색어 예시"
			wrapClassName="home-community-modal"
			open={modalShow}
			centered={true}
			maskClosable={true}
			closable={false}
			onCancel={() => {
				setModalShow(false);
			}}
			width="60%"
			footer={null}
		>
			{isLoading && (
				<Spin
					style={{
						margin: "auto",
						width: "100%",
						paddingTop: "2em",
						position: "absolute",
						left: 0,
						right: 0,
					}}
				/>
			)}
			<img
				src={`/assets/images/channel/white-close.png`}
				alt={`white-close`}
				className={`photo-img`}
				style={{
					position: "absolute",
					top: 0,
					right: "-2.5em",
					width: "2.2em",
					height: "2.2em",
					cursor: "pointer",
				}}
				onClick={() => {
					setModalShow(false);
				}}
			/>
			<div
				className={`home-community-each modal-community community-each-page`}
				onLoad={handleLoad}
			>
				<div className={`home-community-content`}>
					<div className={`community-title-div`}>
						<p
							className={`community-tag`}
							style={{ backgroundColor: `${item?.background_color}` }}
						>
							{item?.category_name}
						</p>
						<p className={`community-title`}>{item?.title}</p>
					</div>
					<CommunityFavorite item={item} type={"header"} />
					{/*<div className={`community-footer-div`}>*/}
					{/*    <p>*/}
					{/*        좋아요 {item?.like_num ?? 0}*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        댓글 {item?.comment_num ?? 0}*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        조회 {Math.ceil(item?.view_num * (5 + (item?.id % 10 / 10)))}*/}
					{/*        /!*{item?.view_num ?? 0}*!/*/}
					{/*    </p>*/}
					{/*    <p>·</p>*/}
					{/*    <p>*/}
					{/*        {moment(item?.created_at).format("YYYY.MM.DD")}*/}
					{/*    </p>*/}
					{/*</div>*/}
					<div className={`community-body-div`}>
						{/*<YoutubeComponent*/}
						{/*    videoId={`adBe7YESvrs`}*/}
						{/*/>*/}
						<p>{item?.body}</p>
						{/*<p className={`body-detail`}>*/}
						{/*    ...자세히보기*/}
						{/*</p>*/}
					</div>
				</div>
				<div className={`home-community-image`}>
					{!!item?.communityImageList?.length && (
						<Image.PreviewGroup>
							{item?.communityImageList?.map((img, index) => (
								<Image
									preview={{
										// visible: false,
										mask: <></>,
										// current: index,
										// countRender: (c,t) => console.log(c, t)
									}}
									key={`list-img-${index}`}
									src={`${process.env.REACT_APP_S3_HOST}/image/together/community/${reduxChannel?.user_id}/${img?.title}.${img?.img_type}`}
									onError={({ currentTarget }) => {
										currentTarget.onerror = null; // prevents looping
										// currentTarget.style.display = "none";
										currentTarget.src = `/assets/images/no-product.png`;
									}}
									alt={`게시판 이미지`}
									style={{
										height: "auto",
										width: "100%",
									}}
									// onClick={() => setVisible(true)}
								/>
							))}
						</Image.PreviewGroup>
					)}
				</div>

				<div
					className={`product-body`}
					style={{
						margin: "0",
						gap: "1em",
					}}
					id={`community-comment-favorite-id`}
					// onLoad={handleLoad}
				>
					<CommunityFavorite item={item} />
					<ChannelCommentComponent
						detail={item}
						type={"community"}
						getCommunity={getCommunity}
						getCommunityList={getCommunityList}
						whereShow={whereShow}
					/>
				</div>
			</div>
		</Modal>
	);
};
export default CommunityModal;
